import React, {useContext, useState} from 'react';
import {FaImage, FaPen} from "react-icons/fa";
import {EditorContext, useEditorState} from "@tiptap/react";
import ImageEditorModal from "../../image-editor-modal/image-editor-modal.jsx";

const RichImageEditorButton = () => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null

    const isImage = useEditorState({
        editor,
        selector: ({ editor }) => {
            if (!editor) return false;

            return (
                editor.isActive("image")
            );
        },
    });

    const [show, setShow] = useState(false);
    const [file, setFile] = useState();

    const handleFile = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.multiple = true;
        input.onchange = event => {
            setFile(event.target.files[0]);
            setShow(true);
        }

        input.click();
    };

    const setImageOnEditor = (imageUrl) => {
        editor.chain().focus().setImage({ src: imageUrl }).run();
    }

    const editFile = async () => {
        if (!editor) return;

        const atributos = editor.getAttributes('image');

        const response = await fetch(atributos.src);
        const blob = await response.blob();

        setFile(new File([blob], "temp", {type: blob.type}));
        setShow(true);
    }

    return (
        <>
            <button
                className="rich-text-button"
                onClick={handleFile}
                title="Adicionar imagem"
            >
                <FaImage className="rich-text-button-icon"/>
            </button>

            {
                isImage &&
                <button
                    className="rich-text-button"
                    onClick={editFile}
                    title="Editar imagem"
                >
                    <FaPen className="rich-text-button-icon"/>
                </button>
            }

            <ImageEditorModal
                show={show}
                setShow={setShow}
                file={file}
                save={setImageOnEditor}
            />
        </>
    );
};

export default RichImageEditorButton;